import enumeration, {TEnumerationValue} from '../../../../Shared/Util/enumeration';

const FocusableComponentRenderStatus = enumeration([
    'RENDERING',
    'RENDERED_PENDING_MOUNT',
    'RENDERED',
    'NULLED',
    'STALE',
]);

type TFocusableComponentRenderStatus = TEnumerationValue<typeof FocusableComponentRenderStatus>;

export type {TFocusableComponentRenderStatus};
export {FocusableComponentRenderStatus as default};
